export const rad2deg = (angleInRadians: number) =>
  (angleInRadians * 180.0) / Math.PI;

export const deg2rad = (angleInDegrees: number) =>
  (angleInDegrees * Math.PI) / 180.0;
